import DialogRef from "./common/DialogRef"
import DynamicImage from "./DynamicImage"

const QrcodeDialog = ({ children }: { children: React.ReactNode }) => {
    return (
        <DialogRef title='立即扫码免费体验' trigger={children} footer={
            <p className="text-center">立即扫码<br></br>获取私域运营增长方案</p>
        }>
            <div className="flex w-full justify-center">
                <DynamicImage
                    src="https://osscdn.weiyouzhihui.com/mall/goods/1758599699501/0%5B1%5D.png"
                    width={250}
                    height={250}
                    alt="微友智汇二维码"
                ></DynamicImage>
            </div>

        </DialogRef>
    )
}

export default QrcodeDialog